import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import TextInput from "../InputComponents/TextInput";
import CommonButton from "../InputComponents/CommonButton";
import { axiosAPI } from "../AxiosComponents/Axios";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";

const ChangePasswordModalCandidate = ({
  open,
  onClose,
  isList = false,
  isStaff = false,
  UL_ID = "",
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [btndisable, setbtndisable] = useState(false);
  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });


  const handleChange = (field, value) => {
    setPasswords((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    // Validation
    if (!isList && !passwords.currentPassword.trim()) {
      infoNotify("Current Password cannot be empty!");
      return;
    }

    if (!passwords.newPassword.trim()) {
      infoNotify("New Password cannot be empty!");
      return;
    }

    if (passwords.newPassword !== passwords.confirmPassword) {
      infoNotify("New Password and Confirm Password do not match!");
      return;
    }

    setbtndisable(true);

    const request = isList
      ? isStaff ?
        axiosAPI?.post(`/Employee/change-password/admin`, {
          UL_ID: UL_ID,
          newPassword: passwords?.newPassword,
        })
        :
        axiosAPI?.post(`/candidate/change-password/admin`, {
          UL_ID: UL_ID,
          newPassword: passwords?.newPassword,
        })
      : axiosAPI?.post(`/Candidate/change-password`, {
        oldPassword: passwords?.currentPassword,
        newPassword: passwords?.newPassword,
      });

    request
      .then((res) => {
        setbtndisable(false);

        if (res?.data?.success) {
          successNotify(res?.data?.message);
          setPasswords({
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
          onClose();
        }
      })
      .catch((err) => {
        setbtndisable(false);
        errorNotify(err?.response?.data?.message || "Something went wrong");
      });
  };

  const fields = isList
    ? ["newPassword", "confirmPassword"]
    : ["currentPassword", "newPassword", "confirmPassword"];

  const labelMap = {
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
  };

  const handleClose = () => {
    // Reset password fields
    setPasswords({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
  
    // Call the parent onClose
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          color: "#0977BC",
          mt: 3,
          mb: 2,
          fontFamily: "Geist, sans-serif",
        }}
      >
        Change Password
      </DialogTitle>

      <DialogContent>
        {fields.map((field) => (
          <Box key={field} sx={{ mb: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 500,
                mb: 1,
                fontFamily: "Geist, sans-serif",
              }}
            >
              {labelMap[field]}
            </Typography>

            <TextInput
              placeholder={labelMap[field]}
              type={showPassword ? "text" : "password"}
              value={passwords[field]}
              onChange={(e) => handleChange(field, e.target.value)}
              endAdornment={
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              }
            />
          </Box>
        ))}
      </DialogContent>

      <DialogActions sx={{ mt: 3, mb: 3, mr: 3 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={handleClose}
          >
            Cancel
          </CommonButton>

          <CommonButton
            variant="contained"
            customColor="#007BFF"
            onClick={handleSubmit}
            disabled={btndisable}
          >
            Save
          </CommonButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordModalCandidate;
